import React, { useState } from 'react';
import { HomePandaSign } from './HomePandaSign';
import './FloatingPandaSign.scss';
import { useTranslation } from 'react-i18next';

interface FloatingPandaSignProps {
  message: string;
}

export const FloatingPandaSign = ({ message }: FloatingPandaSignProps) => {
  const [isPandaVisible, setIsPandaVisible] = useState(false);
  const {t} = useTranslation()

  return (
    <React.Fragment>
      {!isPandaVisible && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px', 
            padding: '10px',
            color: 'white',
            backgroundColor: '#ff1647',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)', 
            cursor: 'pointer',
            animation: 'pulse 2s infinite', 
            transition: 'transform 0.2s', 
            fontWeight: 'bold',
          }}
          onClick={() => setIsPandaVisible(true)}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')} 
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')} 
          aria-label="Open promotion" 
        >
          {t('PROMOTION')}
        </div>
      )}
      <div
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          transform: isPandaVisible ? 'translateX(0)' : 'translateX(150%)',
          transition: 'transform 0.3s ease-in-out',
          zIndex: 1001,
          pointerEvents: isPandaVisible ? 'auto' : 'none',
        }}
      >
        <HomePandaSign message={message} onClick={() => setIsPandaVisible(false)} />
      </div>
    </React.Fragment>
  );
};